import * as ENDPOINTS from 'constants/endpoints';
import * as CONSTANTS from 'constants';

export const getWizardList = () => {
    return {
        type: CONSTANTS.GET_WIZARD_LIST,
        payload: {
            url: ENDPOINTS.ENDPOINT_GET_WIZARD_LIST,
            data: {}
        }
    };
};

export const setWizardList = (data) => {
    return {
        type: CONSTANTS.SET_WIZARD_LIST,
        payload: data
    };
};

export const getWizardSteps = (wizardUUID = '') => {
    return {
        type: CONSTANTS.GET_WIZARD_STEPS,
        payload: {
            url: ENDPOINTS.ENDPOINT_GET_WIZARD_STEPS,
            data: { wizardUUID }
        }
    };
};

export const setWizardSteps = (data) => {
    return {
        type: CONSTANTS.SET_WIZARD_STEPS,
        payload: data
    };
};

export const wizardContactSupport = (stepUUID = '') => {
    return {
        type: CONSTANTS.WIZARD_CONTACT_SUPPORT,
        payload: {
            url: ENDPOINTS.ENDPOINT_WIZARD_CONTACT_SUPPORT,
            data: { stepUUID }
        }
    };
};

export const getUserWizardResponses = (userUUID = '') => {
    return {
        type: CONSTANTS.GET_USER_WIZARD_RESPONSES,
        payload: {
            url: ENDPOINTS.ENDPOINT_GET_USER_WIZARD_RESPONSES,
            data: { userUUID }
        }
    };
};

export const setUserWizardResponses = (data) => {
    return {
        type: CONSTANTS.SET_USER_WIZARD_RESPONSES,
        payload: data
    };
};
